var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackAcceptCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accept-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75865 11.3335L9.79202 13.1635C10.1382 13.4751 10.676 13.4274 10.9619 13.0598L14.1764 8.92684M10.9675 19.3557C15.3981 19.3557 18.9898 15.7641 18.9898 11.3335C18.9898 6.90295 15.3981 3.31128 10.9675 3.31128C6.53698 3.31128 2.94531 6.90295 2.94531 11.3335C2.94531 15.7641 6.53698 19.3557 10.9675 19.3557Z",
    stroke: "#333333",
    strokeWidth: 1.60444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackAcceptCircle);
export default __webpack_public_path__ + "static/media/black_accept_circle.d57e66321f74a746f56d6d868b0c1ab1.svg";
export { ForwardRef as ReactComponent };